import React from "react";
import { Flex } from "../../atoms/flex";

/**
 * Text skeleton
 */

export const TextSkeleton = () => (
  <Flex>
    <div className="textSkeleton" />
    <div className="textSkeleton" />
    <div className="textSkeleton" />
  </Flex>
);
